import FormValidationError from "../entities/error/FormValidationError.js";
import ColorPreset from "../entities/color-scheme/ColorPreset.js";
import AliasColorScheme from "../entities/color-scheme/AliasColorScheme.js";

export default class AliasColorRepository {
	static #RESTRICTED_SYMBOLS = ['\'', '"', '`', '\\'];
	static #VALIDATION_ERROR_MESSAGE = 'Should not contain: ' + AliasColorRepository.#RESTRICTED_SYMBOLS.join(' ');
	/**
	 * @type {GlobalSettingsRepository}
	 */
	#globalSettingsRepository;
	/**
	 * @type {AliasColors}
	 */
	#cached;

	constructor(globalSettingsRepository) {
		this.#globalSettingsRepository = globalSettingsRepository;
		this.#cached = null;
	}

	async getAliasColors() {
		return this.#getCachedOrLoad();
	}

	async set(alias, color) {
		this.#validateAlias(alias);
		this.#cached.set(alias, color);
		return this.#save();
	}

	async delete(alias) {
		this.#cached.delete(alias);
		return this.#save();
	}

	async update(oldAlias, aliasColor) {
		this.#validateAlias(aliasColor.alias)
		this.#cached.delete(oldAlias);
		this.#cached.set(aliasColor.alias, aliasColor.color);
		return this.#save();
	}

	/**
	 * @returns {Promise<AliasColorScheme>}
	 */
	async getGlobalColorScheme() {
		const colorScheme = new AliasColorScheme();
		const aliasColors = await this.#getCachedOrLoad();
		colorScheme.setGlobalColorPreset(new ColorPreset(aliasColors.asArray()));
		return colorScheme;
	}

	async #getCachedOrLoad() {
		if (!this.#cached)
			this.#cached = await this.#globalSettingsRepository.getAliasColors();
		return Promise.resolve(this.#cached);
	}

	async #save() {
		return this.#globalSettingsRepository.saveProp('alias_colors', this.#cached.toServerString());
	}

	#validateAlias(alias) {
		for (const symbol of AliasColorRepository.#RESTRICTED_SYMBOLS)
			if (alias.includes(symbol))
				throw new FormValidationError("alias", AliasColorRepository.#VALIDATION_ERROR_MESSAGE);
	}
}